<template>
  <div>
    <b-card no-body class="cards card-box">
      <div class="p-2">
        <b-button variant="primary" v-if="ehAdmin" @click="abrirCadastrar">{{
          $t("GERAL.NOVO")
        }}</b-button>
      </div>

      <tabela-padrao
        sem-selecionar-todos
        v-model="tabela.dados"
        :colunas="tabela.colunas"
        :quantidade-itens="tabela.quantidadeItens"
        ref="tabela"
        backend-paginado
        @paginar="listar"
        @doisClicksLinha="abrirEditar"
      >
        <template #cell(acoes)="linha">
          <div class="d-flex">
            <b-button
              variant="flat-primary"
              v-if="permissao.r"
              @click="abrirEditar(linha.item)"
            >
              <i class="fas fa-edit"></i>
            </b-button>
            <b-button variant="flat-danger" v-if="ehAdmin" @click="excluir(linha.item)">
              <i class="fas fa-trash"></i>
            </b-button>
          </div>
        </template>
      </tabela-padrao>
    </b-card>
  </div>
</template>

<script>
import Confirmacao from "@/components/confirmacao/Confirmacao";
import EmpresasService from "@/common/services/empresas/empresas.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Swal from "sweetalert2";

export default {
  name: "Empresas",

  data() {
    return {
      tabela: {
        dados: [],
        colunas: [
          {
            key: "nomeFantasia",
            label: "Empresa",
            formatter: (a, b, c) => {
              return c.nomeFantasia || c.razaoSocial;
            },
          },
          {
            key: "cnpj",
            label: this.$t("GERAL.CNPJ_EMPRESA"),
            formatter: (value) => {
              if (value) return helpers.maskCnpj(value);
            },
          },
          {
            key: "tipo",
            label: this.$t("GERAL.TIPO"),
          },
          {
            key: "endereco.uf",
            label: "Estado",
          },
          {
            key: "acoes",
            label: this.$t("GERAL.ACOES"),
            tdClass: "acoes",
          },
        ],
        quantidadeItens: 0,
        paginaAtual: 0,
        porPagina: 0,
      },
    };
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: this.$t("MENU.EMPRESAS") }]);
    this.listar();
  },
  computed: {
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("Empresas");
    },
  },
  methods: {
    listar: function (paginaAtual = 0, porPagina = 10) {
      this.$store.dispatch(START_LOADING);
      EmpresasService.listar(porPagina, paginaAtual)
        .then((res) => {
          this.tabela.dados = res.data.data.itens;
          this.paginaAtual = paginaAtual;
          this.porPagina = porPagina;
          this.tabela.quantidadeItens = res.data.data.paginacao.totalDeElementos;
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    abrirCadastrar() {
      this.$router.push({ name: "empresas-formulario" });
    },
    abrirEditar(item) {
      if (this.permissao.r)
        this.$router.push({
          name: "empresas-formulario",
          params: { id: item.id },
        });
    },
    excluir(item) {
      Confirmacao.SimNao(
        this,
        null,
        this.$t("EMPRESAS.CONFIRMAR_EXCLUIR_EMPRESA").formatUnicorn({
          nome: item.nome,
        })
      ).then(async (result) => {
        if (result.value) {
          this.$store.dispatch(START_LOADING);
          EmpresasService.excluir(item.id)
            .then(() => {
              Swal.fire({
                title: this.$t("GERAL.SUCCESSO"),
                text: this.$t("EMPRESAS.MENSAGEM_EXCLUIDO"),
                icon: "success",
                confirmButtonText: this.$t("GERAL.OK"),
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router.go();
                }
              });
            })
            .catch((err) => {
              Swal.fire({
                title: this.$t("GERAL.ERRO"),
                text: err.response.data.errors,
                icon: "error",
              });
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
  },
};
</script>
